import { ProductRepository } from './infrastructure/ProductRepository'

import { GetProductBySku } from './use-cases/GetProductBySku'
import { GetProductList } from './use-cases/GetProductList'

export const productRepository = new ProductRepository()

export const getProductList = new GetProductList(productRepository)
export const getProductBySku = new GetProductBySku(productRepository)
